import React from 'react';
import { PAGES, usePageMeta } from '../seo/seo';

const AboutUs = () => {
  usePageMeta(PAGES.about);
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      {/* Hero Section */}
      <div className="bg-gradient-to-br from-[#3399FF] to-[#36AC98] text-white">
        <div className="max-w-7xl mx-auto px-4 py-16">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">About Us</h1>
            <p className="text-xl opacity-90 max-w-2xl mx-auto">
              Revolutionizing Excel with the Power of Web & AI
            </p>
          </div>
        </div>
      </div>
      <div className="max-w-7x1 mx-auto px-4">
        <div className="grid md:grid-cols-1 gap-4">
          <div className="min-h-screen bg-gray-100 flex flex-col items-center justify-center p-6">
             <div className="max-w-4xl bg-white shadow-lg rounded-xl p-44"> 
                <p className="text-lg text-gray-700  mb-4">
                At <strong className="text-[#3399FF]">CognitAIX</strong>, we are redefining how professionals interact with Excel by seamlessly
                integrating the power of Web and AI into their daily workflows. Our flagship product, <strong>WebAIExcel</strong>,
                eliminates inefficiencies, automates tedious tasks, and provides real-time insights—all within Excel.
                </p>
                
                <h2 className="text-2xl font-semibold text-[#3399FF] mt-6">Our Mission</h2>
                <p className="text-gray-700 mt-2">
                We empower professionals in healthcare, finance, risk management, and operations by bridging the gap between traditional
                spreadsheets and modern AI-driven technology. Our goal is simple: <strong>enhance Excel without replacing it</strong>,
                ensuring users can leverage the latest innovations while keeping their data secure and workflows intact.
                </p>
                
                <h2 className="text-2xl font-semibold text-[#3399FF] mt-6">Why We Built WebAIExcel</h2>
                <ul className="list-disc list-inside text-gray-700 mt-2">
                <li>Bringing live web data and AI insights directly into Excel.</li>
                <li>Eliminating manual data transfers and improving workflow automation.</li>
                <li>Ensuring enterprise-grade data security while working with AI models.</li>
                </ul>
                
                <h2 className="text-2xl font-semibold text-[#3399FF] mt-6">Our Commitment</h2>
                <p className="text-gray-700 mt-2">
                We are a team of financial and technology experts with decades of experience in fintech, cloud computing, and AI.
                We understand the <strong>unique challenges professionals face</strong>, and we are committed to delivering
                <strong> secure, scalable, and efficient solutions</strong> tailored to their needs.
                </p>
                
                <p className="text-lg text-[#3399FF] font-semibold mt-6">
                At CognitAIX, we believe <strong>Excel should work for you, not the other way around.</strong>
                <br />
                Join us in transforming the future of Excel! 🚀
                </p>
            </div>
            </div>         
        </div>
      </div>
    </div>
  );
};

export default AboutUs;